import { FunctionComponent } from 'react'

import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'
import { isNotNil } from '../validation/helpers'

export const StringFormatter: FunctionComponent<Formatter<string>> = ({ value, t }) =>
  isNotNil(value) ? value : t(tDefaults('inputs.no-answer'))
